import axiosClient from "./axiosClient";
import {Result} from "./types";
import {getTokenCookie} from "libs";
import axios from 'axios';

export class EbookApi {
    config: any

    constructor() {
        const token = getTokenCookie()
        this.config = {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        }
    }

    getEbookList = async (offset: number): Promise<Result> => {
        return await axiosClient.get(`/management/ebook/list/${offset}`, this.config)
    }
    getEbookFilter = async (offset: number, title: string): Promise<Result> => {
        return await axiosClient.get(`/management/ebook/filter/${offset}?title=${title}`, this.config)
    }
    deleteEbook = async (data: any): Promise<Result> => {
        return await axiosClient.delete(`/management/book/delete/${data}`, this.config);
    }
    getEbookFeed = async (page: number): Promise<Result> => {
        return await axiosClient.get(`/ebook/feed/${page}`, this.config)
    }
    getEbookFeedTitle = async (page: number, title: string): Promise<Result> => {
        return await axiosClient.get(`/ebook/feed/title/${page}?title=${title}`, this.config)
    }
    getEbookFeedSubject = async (page: number, subject: string): Promise<Result> => {
        return await axiosClient.get(`/ebook/feed/subject/${page}?subject=${subject}`, this.config)
    }
    getEbookDetail = async (id: string): Promise<Result> => {
        return await axiosClient.get(`/ebook/detail/${id}`, this.config)
    }

    getBorrowerList = async (offset: number, id: string): Promise<Result> => {
        return await axiosClient.get(`/ebook/list-borrower/${id}/${offset}`, this.config)
    }
    getRatingList = async (offset: number, id: string): Promise<Result> => {
        return await axiosClient.get(`/ebook/rating/view/${id}/${offset}`, this.config)
    }
    getQueueList = async (id: string): Promise<Result> => {
        return await axiosClient.get(`/ebook/list-queue/${id}`, this.config)
    }


    postEbookRead = async (id: string): Promise<Result> => {
        return await axiosClient.post(`/ebook/read/${id}`, {}, this.config);
    }

    postEbookRating = async (data: any): Promise<Result> => {
        return await axiosClient.post(`/ebook/rating/post`, data, this.config);
    }
    postEbookBorrow = async (id: string): Promise<Result> => {
        return await axiosClient.post(`/ebook/borrow/${id}`, {}, this.config);
    }
    postEbookSession = async (data: any): Promise<Result> => {
        return await axiosClient.post(`/ebook/read/end-session`, data, this.config);
    }

    postEbookCreate = async (data: any): Promise<Result> => {
        return await axiosClient.post(`/management/book/create`, data, this.config);
    }

    uploadEbook = async (file: any): Promise<any> => {
        const formData = new FormData();
        formData.append('file', file);
        const {data} = await axios.post(`/api/uploads/ebooks`, formData, {
            headers: {
                'content-type': 'multipart/form-data'
            },
            onUploadProgress: (event) => {
                console.log(`Current progress:`, Math.round((event.loaded * 100) / event.total));
            },
        });
        return data;
    }
}
